import { apiPost } from "./client";

export function validatePromo(payload) {
  return apiPost("/utility/promos/", payload);
}
